import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Warning from "../../../assets/kinologyIcons/svg/paymentWithCard.svg";
import {ReactComponent as Close} from "../../../assets/kinologyIcons/svg/close.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import { ActivityIndicator } from "../../../components/Buttons/FormSubmitButton/style";
import { FaturaProps } from "../../../interfaces/cartao.interface";
import { TextsProps } from "../../../database/txt.interface";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalPagamentoComCartao: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const load = useSelector((state: any) => state.financial.loading_card);

	const modalVisible = useSelector(	(state: any) => state.financial.modal_pagamento_cartao);
	const dataFaturaAtual: FaturaProps = useSelector(	(state: any) => state.financial.modal_pagamento_cartao_data);

	const handleClose = () => {
		dispatch(FinancialActions.set_modal_pagamento_cartao(false, null));
	};

	const handleSelectOption = (option: string) => {
		handleClose();
	};
	const formatPrice = (price: number) =>	(price / 100)?.toFixed(2).replace(/\./g, ",");


	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={modalVisible}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={modalVisible}>
				<ModalContainer>
					<ModalContent>
						<CloseButton onClick={handleClose}>
							<Close width={18} height={18} style={{right:5, top:10,  position: 'absolute'}}/>
						</CloseButton>
						<IconContainer>
							<img style={{ width: "4rem", height: "4rem" }} src={Warning} />
						</IconContainer>
						<Title>{current_language?.pagamento_cartao_cadastrado}</Title>
						<Title style={{fontWeight:'400' }}>{current_language?.valor_fatura}</Title>
						<Title>{`R$ ${formatPrice(Number(dataFaturaAtual?.FATURA_VALOR))}`}</Title>
						<Button 
							onClick={() => {
								dispatch(FinancialActions.set_load_card(true));
								dispatch(FinancialActions.set_request_pay_envoice())
							}}
							style={{
								display:  "flex",
								backgroundColor: '#009973',
								color: '#FFFFFF',
								justifyContent: 'center'
							}}
						>
							{ load 
								? <ActivityIndicator  style={{height: 18, width: 18}} />
								: current_language?.pagar_cartao_cadastrado
							}
						</Button>
						<Button onClick={() =>{handleClose()}}>
							{current_language?.pagamento_cancelar}
						</Button>
					
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	position: relative;
`;

const CloseButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background: none;
	border: none;
	font-size: 30px;
	cursor: pointer;
`;

const IconContainer = styled.div`
	margin-bottom: 16px;
	margin-top: 16px;
`;

const Title = styled.h2`
	font-size: 16px;
	color: #002060;
	margin: 0 0 16px;
`;

const Button = styled.button`
	width: 100%;
	padding: 12px;
	font-size: 14px;
	font-weight: bold;
	color: #009973;
	background-color: white;
	border: 1px solid #009973;
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	&:hover {
		background-color: #f6f6f6;
	}
`;

export default ModalPagamentoComCartao;
